<template>
  <div>
    <Loading v-if="isLoading"></Loading>
    <div
      v-if="!isLoading"
      class="learn-home d-flex flex-column justify-content-center  align-items-center bd-highlight mb-3"
      style="margin-top:150px"
    >
      <jobs-card
        v-for="(job, index) in jobs"
        :key="index"
        :job="job"
        class="w-75"
      />
    </div>
  </div>
</template>

<script>
import router from "../router";
import JobsCard from "../components/Utilities/Cards/Jobs.vue";
import Loading from "./Loading";

import axios from "axios";
export default {
  components: { JobsCard, Loading },
  data() {
    return {
      articles: [],
      isLoading: false,
      jobs: [],
    };
  },
  created() {
    this.getJobs();
  },
  methods: {
    navigate(id) {
      router.push({ path: `/jobs/${id}` });
      // console.log(slug);
    },
    getJobs() {
      axios
        .get("https://api.ardunic.com/v1/jobs")
        .then((res) => (this.jobs = res.data.data));
    },
  },
};
</script>

<style>
.learn-home {
  margin-top: 90px;
}

.class-card {
  background-image: url("https://images.unsplash.com/photo-1550314124-301ca0b773ae?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1015&q=80.png");
  background-size: cover;
  width: 100%;
  height: 250px;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  color: white;
}

.class-card h2 {
  margin-top: 38%;
}

.brands-classes {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid #aaaaaa;
  border-radius: 25px;
}

.brands-classes img {
  padding: 10px;
  padding: 25px;
}
</style>
